module.exports = new __parcel__URL__("exercise4.7463e032.png").toString();